import { Component, OnInit, AfterContentInit, ViewChild, ElementRef } from '@angular/core';
import { StatefulCSS } from './../model/stateful_css';
import * as $ from 'jquery';
import { SlWapiService } from '../model/api-services/sl-wapi.service';
import { ActivatedRoute, Router } from '@angular/router';
import { HttpErrorResponse } from '@angular/common/http';
import { EnvService } from '../env.service';
import { SLWapiError } from '../types/@types/sl-v-types';

@Component({
	selector: 'app-login',
	templateUrl: './login.component.html',
	styleUrls: ['./login.component.scss'],
	// tslint:disable-next-line: no-host-metadata-property

})
export class LoginComponent implements AfterContentInit, OnInit {
	static FWD = 'forward';
	static BWD = 'backward';

	@ViewChild('name_input', { static: true }) nameInputRef: ElementRef;
	@ViewChild('pw_input', { static: true }) pwInputRef: ElementRef;
	@ViewChild('login_view', { static: true }) domElementRef: ElementRef;
	@ViewChild('back_btn', { static: true }) backBtnRef: ElementRef;
	@ViewChild('next_btn', { static: true }) nextBtnRef: ElementRef;
	@ViewChild('loginForm', { static: true }) loginFormRef: ElementRef;

	private loadStates: StatefulCSS;
	private errorStates: StatefulCSS;

	public loginMessage = 'PLEASE LOG IN TO CONTINUE';
	constructor(
		private wapi: SlWapiService,
		private route: ActivatedRoute,
		private router: Router,
		private env: EnvService) {
		this.wapi.SetAppName('SimpleMap_v5');
	}

	ngOnInit(): void {
		this.nameInputRef.nativeElement.addEventListener('keyup', (event) => {
			this.UpdateNavButtons();
			if (event.key === 'Enter') {
				this.UpdateButtons(LoginComponent.FWD);
			}
		});
		this.nameInputRef.nativeElement.addEventListener('change', () => {
			this.UpdateNavButtons();
		});
		this.pwInputRef.nativeElement.addEventListener('keyup', (event) => {
			this.UpdateNavButtons();
			if (event.key === 'Enter') {
				this.UpdateButtons(LoginComponent.FWD);
			}
		});
		this.pwInputRef.nativeElement.addEventListener('change', () => {
			this.UpdateNavButtons();

		});
		setTimeout(() => {
			$(this.nameInputRef.nativeElement).trigger('change');
		}, 0);

	}
	ngAfterContentInit(): void {
		this.loadStates = new StatefulCSS(['waiting-for-username', 'waiting-for-pw', 'authenticating'],
			this.domElementRef.nativeElement, 'login');
		this.errorStates = new StatefulCSS(['ok', 'problem'], this.domElementRef.nativeElement, 'status');
		this.errorStates.SetState('ok');

		this.loadStates.SetState('waiting-for-username');
		$(this.backBtnRef.nativeElement).on('click', () => {
			this.UpdateButtons(LoginComponent.BWD);
		});
		$(this.nextBtnRef.nativeElement).on('click', () => {
			this.UpdateButtons(LoginComponent.FWD);
		});
		this.UpdateNavStates();

	}
	UpdateNavButtons(): void {
		if (!!this.nextBtnRef) {
			if (!this.GetCurrentInput()) {
				return;
			}
			$(this.nextBtnRef.nativeElement).prop('disabled', this.GetCurrentInput().nativeElement.value.length === 0);
		}
	}
	UpdateNavStates(): void {
		switch (this.loadStates.GetCurrentState()) {
			case 'waiting-for-username':
			case 'login-problem':
				$(this.domElementRef.nativeElement).toggleClass('has-prev', false);
				$(this.domElementRef.nativeElement).toggleClass('has-next', true);
				break;
			case 'waiting-for-pw':
				$(this.domElementRef.nativeElement).toggleClass('has-prev', true);
				$(this.domElementRef.nativeElement).toggleClass('has-next', true);
				break;
			default:
				$(this.domElementRef.nativeElement).toggleClass('has-prev', false);
				$(this.domElementRef.nativeElement).toggleClass('has-next', false);
				break;
		}
		this.UpdateNavButtons();
	}
	UpdateButtons(direction: string): void {
		switch (this.loadStates.GetCurrentState()) {
			case 'waiting-for-username':
			case 'login-problem':
				$(this.domElementRef.nativeElement).toggleClass('first-run', false);
				this.loadStates.SetState(direction === LoginComponent.FWD ? 'waiting-for-pw' : 'waiting-for-username');
				this.pwInputRef.nativeElement.focus();
				break;
			case 'waiting-for-pw':
				this.loadStates.SetState(direction === LoginComponent.FWD ? 'authenticating' : 'waiting-for-username');
				const pw = this.pwInputRef.nativeElement.value;
				this.pwInputRef.nativeElement.value = '';

				if (direction === LoginComponent.FWD) {
					this.wapi.Authenticate(this.nameInputRef.nativeElement.value,
						pw).then(() => {
							this.HandleAuthenticated();
						}).catch((error: HttpErrorResponse | SLWapiError) => {
							if (error.hasOwnProperty('name')) {
								this.HandleHTTPError(error as HttpErrorResponse);
							} else {
								this.HandleSLWapiError(error as SLWapiError);
							}
						});
				} else {
					setTimeout(() => {
						this.pwInputRef.nativeElement.focus();
					}, 2000);

				}
		}

		this.UpdateNavStates();

	}
	HandleHTTPError(error: HttpErrorResponse) {
		this.DisplayProblem('A communication problem occurred');
	}
	HandleSLWapiError(error: SLWapiError) {
		this.DisplayProblem('The provided credentials were not recognized');
	}
	DisplayProblem(message: string) {
		this.loginMessage = message;
		this.loadStates.SetState('waiting-for-username');
		this.errorStates.SetState('problem');
		this.UpdateNavStates();

	}

	HandleAuthenticated() {
		this.router.navigate([this.wapi.GetAuthTo()]);
	}
	GetCurrentInput(): ElementRef | null {
		switch (this.loadStates.GetCurrentState()) {
			case 'waiting-for-username':
				return this.nameInputRef;
			case 'waiting-for-pw':
				return this.pwInputRef;
		}
		return null;

	}

}
